import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7abb857a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FlightDepartures" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_6 = { class: "mt-6" }
const _hoisted_7 = {
  key: 1,
  class: "flex items-center justify-center mt-3 bg-white rounded py-3 px-4"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Загрузка списка...", -1))
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "flex items-center justify-end bg-white rounded py-3 px-4" }
const _hoisted_11 = { class: "overflow-hidden overflow-x-auto" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_flight_departures_actions = _resolveComponent("flight-departures-actions")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_flight_departures_filters = _resolveComponent("flight-departures-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_loader = _resolveComponent("loader")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_new_table = _resolveComponent("new-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_flight_departures_actions, {
          key: 0,
          "is-update": _ctx.actions_state.is_update,
          loading: _ctx.actions_state.is_actions_loading,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
          onUpdate: _ctx.onFlightDepartureUpdate,
          onCreate: _ctx.onFlightDepartureCreate
        }, null, 8, ["is-update", "loading", "onUpdate", "onCreate"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, {
        title: "Список графиков",
        class: "mb-6"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_the_button, {
          disabled: _ctx.state.is_excel_loading,
          loading: _ctx.state.is_excel_loading,
          hint: "Скачать Excel",
          class: "primary small mr-3",
          onClick: _ctx.exportExcel
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["disabled", "loading", "onClick"]),
        _createVNode(_component_the_button, {
          class: "primary small",
          onClick: _ctx.startCreate
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" Добавить график ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createVNode(_component_flight_departures_filters, {
      loading: _ctx.state.flight_departures.is_loading,
      onSearch: _ctx.applyFilters,
      onReset: _ctx.resetFilters
    }, null, 8, ["loading", "onSearch", "onReset"]),
    _createElementVNode("div", _hoisted_6, [
      (
                    _ctx.state.flight_departures.is_failed &&
                    !_ctx.state.flight_departures.failure.error_state.is_cancel
                )
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.flight_departures.is_loading,
            text: "При получении списка графиков произошла ошибка",
            "error-message": _ctx.state.flight_departures.failure.error_state.message,
            "error-url": _ctx.state.flight_departures.failure.error_state.url,
            "error-status": _ctx.state.flight_departures.failure.error_state.status,
            onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadFlightDepartures(_ctx.state.flight_departures.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_ctx.state.flight_departures.is_loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_loader, { class: "primary mr-1" }),
              _hoisted_8
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_new_limit, {
                  disabled: _ctx.state.flight_departures.is_loading,
                  value: _ctx.state.limit,
                  "total-items": _ctx.state.flight_departures.pagination.total_items,
                  onChange: _ctx.onLimitChange
                }, null, 8, ["disabled", "value", "total-items", "onChange"]),
                _createVNode(_component_new_pagination, {
                  class: "ml-6",
                  disabled: _ctx.state.flight_departures.is_loading,
                  "current-page": _ctx.state.flight_departures.pagination.current_page,
                  "total-pages": _ctx.state.flight_departures.pagination.total_pages,
                  onChangePage: _ctx.onChangePage
                }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_new_table, {
                  columns: _ctx.FlightDeparturesColumns,
                  rows: _ctx.state.flight_departures.list
                }, {
                  td: _withCtx(({ column, row }) => [
                    (column.key === 'statusDescription')
                      ? (_openBlock(), _createBlock(_component_cheap, {
                          key: 0,
                          class: _normalizeClass(_ctx.getCheapClass(row.statusDescription))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.statusDescription), 1)
                          ]),
                          _: 2
                        }, 1032, ["class"]))
                      : (column.key === 'departureAt')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.formatDate(row[column.key])), 1)
                          ], 64))
                        : (column.key === 'arrivalAt')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode(_toDisplayString(_ctx.formatDate(row[column.key])), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                            ], 64))
                  ]),
                  actions: _withCtx(({ row }) => [
                    _createVNode(_component_the_button, {
                      hint: "Редактировать",
                      class: "yellow extra-small",
                      loading: _ctx.state.is_loading,
                      onClick: ($event: any) => (_ctx.startUpdate(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 2
                    }, 1032, ["loading", "onClick"])
                  ]),
                  _: 1
                }, 8, ["columns", "rows"])
              ])
            ]))
    ])
  ]))
}